import React from "react";
import { Typography } from "@mui/material";

/**
 * A reusable component for section headers
 * 
 * @param {Object} props - Component props
 * @param {string} props.title - Header title
 * @param {string} props.variant - Typography variant
 * @param {string} props.align - Text alignment
 * @param {Object} props.theme - Theme object
 * @param {Object} props.sx - Additional styles
 */
const CHeader = ({
  title,
  variant = "h6",
  align = "left",
  theme,
  sx = {},
  ...otherProps
}) => {
  return (
    <Typography
      variant={variant}
      align={align}
      sx={sx}
      gutterBottom
      {...otherProps}
    >
      {title}
    </Typography>
  );
};

export default CHeader;